var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tranche-update-class-a-type-container"},[_c('b-form-checkbox',{staticClass:"tranche-update-class-a-type",attrs:{"id":_vm.getId()},on:{"change":function($event){_vm.patchClassA($event)}},model:{value:(_vm.classA),callback:function ($$v) {_vm.classA=$$v},expression:"classA"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b7a58d6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/TrancheUpdateClassAType.vue
// module id = null
// module chunks = 